import React, { Ref } from 'react';
import ReactMarkdown from 'react-markdown';
import mergeRefs from 'react-merge-refs';

import { RadioButtonPanels } from '@eika/radio-button';

import { FocusableHtmlElement, useFocusRef } from '../../sporsmalsflyt/hooks';
import { ForsikringAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';

import '../radio-buttons/radio-buttons.scss';

export const selectedAlternativValue = (forsikringsnummer: string, versjon: number): string =>
    `${forsikringsnummer}-${versjon}`;

export interface OptionProps {
    label: string;
    description?: string;
    id?: string;
    value: string;
    forsikringsnummer: string;
    versjon: number;
}

interface Props {
    name: string;
    title: string;
    info?: string;
    ingress?: string;
    options: OptionProps[];
    onChange: (eventValue: string) => void;
    selectedOption?: ForsikringAlternativ;
    focusOnMount: boolean;
    error?: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
}

export const ForsikringButtons = ({
    name,
    title,
    info = null,
    ingress = null,
    options,
    onChange,
    selectedOption,
    focusOnMount = true,
    error,
    errorRef,
}: Props) => {
    const optionRef = useFocusRef<HTMLInputElement>(focusOnMount);

    const optionShouldHaveFocus = (option: OptionProps, index: number) => {
        return (
            (selectedOption &&
                selectedOption.forsikringsnummer === option.forsikringsnummer &&
                selectedOption.forsikringversjon === option.versjon) ||
            (!selectedOption && index === 0)
        );
    };

    return (
        <div className="container__standard-width">
            <div className="info-container">
                <ReactMarkdown>{info}</ReactMarkdown>
            </div>
            <RadioButtonPanels
                label={title}
                sublabel={ingress}
                options={options.map((option, index) => {
                    if (optionShouldHaveFocus(option, index)) {
                        return { ...option, ref: mergeRefs([optionRef, errorRef]) };
                    }
                    return option;
                })}
                selectedOption={
                    selectedOption
                        ? selectedAlternativValue(selectedOption.forsikringsnummer, selectedOption.forsikringversjon)
                        : undefined
                }
                onChange={onChange}
                name={name}
                errorMessage={error ? 'Du må velge et alternativ' : undefined}
                required
            />
        </div>
    );
};
